// extracted by mini-css-extract-plugin
export var closeButton = "_2t-3";
export var header = "_2t-0";
export var link = "_2t-1";
export var retryButton = "_2t-2";